import React, { useEffect } from "react";
import { AccentButton } from "@/components/shared/Primitives";

// Calendly inline/popup widget. The script tag at assets.calendly.com is a
// third-party widget that does not support SRI — that is normal for Calendly.
export const CALENDLY_URL =
  "https://calendly.com/emailink/call-with-jordan?hide_event_type_details=1&hide_gdpr_banner=1";

const WIDGET_JS = "https://assets.calendly.com/assets/external/widget.js";
const WIDGET_CSS = "https://assets.calendly.com/assets/external/widget.css";

let scriptInjected = false;

// Lazily inject the Calendly widget assets once, on demand.
export function ensureCalendly() {
  if (typeof window === "undefined" || scriptInjected) return;
  scriptInjected = true;

  if (!document.querySelector(`link[href="${WIDGET_CSS}"]`)) {
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = WIDGET_CSS;
    document.head.appendChild(link);
  }

  if (!document.querySelector(`script[src="${WIDGET_JS}"]`)) {
    const script = document.createElement("script");
    script.src = WIDGET_JS;
    script.async = true;
    document.body.appendChild(script);
  }
}

// Open the Calendly scheduling popup. Falls back to a new tab if the widget
// script has not finished loading yet.
export function openCalendly() {
  if (typeof window !== "undefined" && window.Calendly) {
    window.Calendly.initPopupWidget({ url: CALENDLY_URL });
  } else if (typeof window !== "undefined") {
    window.open(CALENDLY_URL, "_blank", "noopener,noreferrer");
  }
}

// Reusable "Book a call" button that opens the Calendly popup on click.
// Accepts the same props as AccentButton (variant, className, data-testid…).
export const BookCallButton = ({ children = "Book a call", onClick, ...props }) => {
  useEffect(() => {
    ensureCalendly();
  }, []);

  const handleClick = (e) => {
    e.preventDefault();
    openCalendly();
    if (onClick) onClick(e);
  };

  return (
    <AccentButton onClick={handleClick} {...props}>
      {children}
    </AccentButton>
  );
};
